/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function(){
     $(document).on("click", ".real-review-item .video-control", function() {
       var clickedControl = $(this);
       var clickedVideo = clickedControl.closest('.popup-video').find('video')[0];
       var videoHtml = clickedControl.closest('.video-item').html();

       // Move the video to the main popup
       $('.review-main-popup').html(videoHtml);

       // Pause all other videos
       $('.popup-video video').not(clickedVideo).each(function() {
           this.pause();
           $(this).siblings('.video-control').removeClass('btnhide');
       });

       // Toggle play/pause and update control icon for the video in the main popup
       var mainPopupVideo = $('.review-main-popup video')[0];
       if (mainPopupVideo.paused) {
           mainPopupVideo.play();
           $('.review-main-popup .video-control').addClass('btnhide');
       } else {
           mainPopupVideo.pause();
           $('.review-main-popup .video-control').removeClass('btnhide');
       }

       // Activate the main popup
       $('.review-main-popup').addClass('video-active');
       $('body').addClass('video-popup-active');
   });

     $(document).on("click", ".review-main-popup .icon-close", function() {
       // Pause and close the video in the main popup
       var mainPopupVideo = $('.review-main-popup video')[0];
       if (mainPopupVideo) {
           mainPopupVideo.pause();
           $('.review-main-popup .video-control').removeClass('btnhide');
       }

       $('body').removeClass('video-popup-active');
       $('.review-main-popup').removeClass('video-active');
       $('.review-main-popup').empty();
  });
   $('body').click(function(e) {
     var mainPopupVideo = $('.review-main-popup video')[0];
       if (mainPopupVideo) {
           mainPopupVideo.pause();
           $('.review-main-popup .video-control').removeClass('btnhide');
       }

       $('body').removeClass('video-popup-active');
       $('.review-main-popup').removeClass('video-active');
       $('.review-main-popup').empty();
})
   $(document).on("click", ".review-main-popup .icon-volume", function() {
    var mainPopupVideo = $(this).parents('.review-main-popup').find('video')[0];
   	if (mainPopupVideo) {
   		mainPopupVideo.muted = !mainPopupVideo.muted;
   		$(this).toggleClass("volume-muted", mainPopupVideo.muted);
   	}
   });
});